import { makeStyles } from "@material-ui/core";

export const WinHistoryStyles = makeStyles(theme => ({
  headerPadding: {
    paddingBottom: "32px",
  },
  searchButton: { margin: "8px 8px 8px 8px", padding: "7px 20px 7px 20px" },
}));
